import { useQuery } from "@tanstack/react-query";

import { getProjectsProjectIDJobsJobID } from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { PROJECTS_QUERY_KEYS } from "./queryKeys";

export function useJobDetailQuery(projectId: string, jobId: string) {
  return useQuery({
    queryKey: PROJECTS_QUERY_KEYS.jobDetail(projectId, jobId),
    queryFn: processResponse(() =>
      getProjectsProjectIDJobsJobID(projectId, jobId),
    ),
    enabled: !!projectId && !!jobId,
  });
}
